import { Container, Row, Col,Button, ButtonGroup,Image } from "react-bootstrap";
import { useState } from "react";
import emo_category_icon from "../../images/emo_category.png";
import FEAI_icon from "../../images/FEAI_icon.png";
import fer2013_sneak_peak from "../../images/fer2013_sneak_peak.png";
import fer2013_distributions from "../../images/fer2013_distributions.png";
import MouseHoverInfoTooltip from "./MouseHoverInfoTooltip";
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import affectnet_sample from "../../images/affectnet_sample.png"
import Thinking_AI from "../../images/AI_thinking.png";
import Learning_AI from "../../images/learning_ai.png";
import welcome_AI from "../../images/Welcome_ai.png";

import ResNet50ArchitectureTooltip from "./ResNet50ArchitectureTooltip";
import icon_one from "../../images/introPageIcon.png"
import icon_two from "../../images/introPageIcon2.png"
import icon_three from "../../images/introPageIcon3.png"
import icon_step_one from "../../images/step_one.png"
import icon_step_two from "../../images/step_two.png"
import icon_step_three from "../../images/step-three.png"
import icon_step_four from "../../images/step-four.png"
import gradcam_sample from "../../images/gradcam.png";
import guided_gradcam_sample from "../../images/guided_gradcam.png";
import dataset_explain from "../../images/dataset_explain.jpg"
import human from "../../images/human.png";
import method_one from "../../images/Method_one.png";
import method_two from "../../images/Method_two.png"

import './StudyOneInstruction.css'
import { steps } from "framer-motion";

const rootStyles = getComputedStyle(document.documentElement);
const data = [
    { name: 'Surprise', value: 5.0 },
    { name: 'Sad', value: 8.9 },
    { name: 'Happy', value: 46.3},
    { name: 'Fear', value: 2.4 },
    { name: 'Disgust', value: 1.5},
    { name: 'Angry', value: 8.7 },
    { name: 'contempt', value: 1.5 },
    { name: 'Neutral', value: 25.9 },
  ];

const COLORS = [
    rootStyles.getPropertyValue('--surprised-color').trim(),  
    rootStyles.getPropertyValue('--sad-color').trim(),        
    rootStyles.getPropertyValue('--happy-color').trim(),      
    rootStyles.getPropertyValue('--fearful-color').trim(),    
    rootStyles.getPropertyValue('--disgusted-color').trim(),  
    rootStyles.getPropertyValue('--angry-color').trim(), 
    rootStyles.getPropertyValue('--contempt-color').trim(),      
    rootStyles.getPropertyValue('--neutral-color').trim(),    
  ];
  const renderCustomLabel = ({ percent, name, value }) => {
    return `${value}%`;
  };

export default function StudyOneInstructionPageOne(){
    const [selected, setSelected] = useState("human");
    const images = {
        human: human, // 替换成你自己的图片路径
        method1: method_one,
        method2: method_two
    };

    const descriptions = {
        human: "This is the photo as seen through human eyes.",
        method1: "Method One highlights the areas that FEAI generally focuses on, with clearer regions indicating higher attention and blurrier, darker areas indicating lower attention.",
        method2: "Method Two shows higher color saturation outlining the specific regions of interest."
    };

    return (
        <Container className="study-item">
            <Row >
                <h1 style={{ fontWeight: 'bold'}}>What do you think?</h1>
                <br /><br /><br />
                <h1 className="subtitle">Try to communicate with FEAI</h1>


                <Container style={{width:"90%"}}>
                    <p>Unlike humans, FEAI has no feelings and cannot communicate,
                    so we need a channel to understand why it gives the label.</p>
                    <p>We provide two different tools to help the AI express which features it observed to arrive at its results.</p> 


                </Container>
                <Container style={{width:"90%"}}>
                <div style={{ textAlign: "center", marginTop: "30px" }}>
                    <Image 
                        src={images[selected]} 
                        alt={selected} 
                        style={{ width: "60%", border: "1px solid #ccc", borderRadius: "10px" }} 
                        fluid
                    />
                </div>  
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <ButtonGroup>
                        <Button variant="outline-primary" onClick={() => setSelected("human")}>
                            Human
                        </Button>
                        <Button variant="outline-primary" onClick={() => setSelected("method1")}>
                            Method One
                        </Button>
                        <Button variant="outline-primary" onClick={() => setSelected("method2")}>
                            Method Two
                        </Button>
                    </ButtonGroup>
                </div>

                {/* 描述文字 */}
                <div style={{ textAlign: "center", marginTop: "20px", fontSize:"1.1rem" }}>
                    <p>{descriptions[selected]}</p>
                </div>                 
                </Container>


            </Row>
        </Container>
        

    );
};
                    {/* <Row>
                        <Col>
                            <img style={{width: "100%"}} src={gradcam_sample} alt="gradcam_sample" />
                            <p>Method One highlights the areas that the model generally focuses on, with clearer regions indicating higher attention 
                                and blurrier, darker areas indicating lower attention.</p>
                        </Col>
                        <Col>
                            <img style={{width: "100%"}} src={guided_gradcam_sample} alt="guided_gradcam_sample" />
                            <p>Method Two shows higher color saturation outlining the specific regions of interest.</p>
                        </Col>
                    </Row> */}